import React from 'react';

import Styles from "./TableCourseDetails.module.css";

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';



const useStyles = makeStyles(theme => ({
  tableActions: {
    width: '100%',
  },
}));

function createData(category, duration, center ) {
  return { category, duration, center };
}

const rows = [
  createData('Família', '14H', 'Lorem Ipsum' ),
];

export default function DenseTable(props) {
  const classes = useStyles();

  return (
    <div className={Styles["TableCourseDetails"]}>
        <Table className={classes.table} aria-label="Actions table">
          <TableHead>
            <TableRow className={Styles["MuiTableRow-head"]}>
              <TableCell className={Styles["MuiTableCell-head"]} align="left"><div className={Styles["title"]}>Categoria</div></TableCell>
              <TableCell className={Styles["MuiTableCell-head"]} align="left"><div className={Styles["title"]}>Duração</div></TableCell>
              <TableCell className={Styles["MuiTableCell-head"]} align="left"><div className={Styles["title"]}>Centro de Formação</div></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.id} className={Styles["MuiTableBody-root"]}>
                <TableCell className={Styles["MuiTableCell-root"]} align="left" component="th" scope="row">
                  <div className={Styles["subtitle"]}>{props.category}</div> 
                </TableCell>
                <TableCell className={Styles["MuiTableCell-root"]} align="left"><div className={Styles["subtitle"]}>{props.trainingHours}</div></TableCell>
                <TableCell className={Styles["MuiTableCell-root"]} align="left"><div className={Styles["subtitle"]}>{props.trainingCenter}</div></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
    </div>
  );
}